module.exports = __webpack_public_path__ + "img/gmtk.8189a18c.png";